



















































































import {Component, Ref, Vue} from 'vue-property-decorator'
import {Inject} from "typescript-ioc";
import RefreshButton from "@/component/Button/refresh-button.vue";
import CompanyBookTaskApi, {CbookTaskPqForm} from "@/api/CompanyBookTaskApi";
import CompanyBookTask from "@/model/CompanyBookTask";
import companyBookModule from "@/store/module/CompanyBookModule";
import PaginationTable from "@/component/Table/pagination-table.vue";
import VueJsonPretty from 'vue-json-pretty';
import InfoDialog from "@/component/Dialog/info-dialog.vue";
import DingtalkAsyncSendResult from "@/model/DingtalkAsyncSendResult";
import {DingtalkTaskType} from '@/model/DingtalkTask';

@Component({
    components: {
        RefreshButton,
        PaginationTable,
        VueJsonPretty,
        InfoDialog,
    },
})
export default class BookTaskView extends Vue {

    @Inject
    private cbookTaskApi!: CompanyBookTaskApi

    private get cbook() {
        return companyBookModule.active
    }

    private pqForm = new CbookTaskPqForm(this.cbook.id)

    @Ref()
    private ptable!: PaginationTable

    private refresh() {
        this.ptable.refresh()
    }

    private async getPaging() {
        const id = String(this.$route.query.id)
        return this.cbookTaskApi.paging(this.pqForm)
    }

    private usersFmt(cbookTask: CompanyBookTask) {
        return cbookTask.items.map(item => {
            return item.user.name
        }).join(", ")
    }

    private resultFmt(cbookTask: CompanyBookTask) {
        const type = cbookTask.dingtalkTask.type
        switch (type) {
            case DingtalkTaskType.ASYNC_SEND_MESSAGE:
                const result = cbookTask.dingtalkTask.result as DingtalkAsyncSendResult
                if (result.readUserIds.length > 0 || result.unreadUserIds.length > 0) return true
                else if (result.forbiddens.length > 0) return false
                break
            default:
                return false
        }
    }

    private msgFmt(cbookTask: CompanyBookTask) {
        const type = cbookTask.dingtalkTask.type
        switch (type) {
            case DingtalkTaskType.ASYNC_SEND_MESSAGE:
                const result = cbookTask.dingtalkTask.result as DingtalkAsyncSendResult
                if (result.readUserIds.length > 0) return "已读"
                else if (result.unreadUserIds.length > 0) return "未读"
                else if (result.forbiddens.length > 0) return result.forbiddens[0].msg
                break
            default:
                return "<未格式化消息>"
        }
    }

    private get contentHeight() {
        return window?.innerHeight - 380
    }

    @Ref()
    private jsonDialog!: InfoDialog

    private cbookTask = new CompanyBookTask()

    private handleDetailClick(cbookTask: CompanyBookTask) {
        this.cbookTask = cbookTask
        this.jsonDialog.open()
    }
}
